import { createContext } from 'react'

const UserContext = createContext([null, false])
UserContext.displayName = 'UserContext'

export default UserContext
